"use client";
import * as Dialog from "@radix-ui/react-dialog";
import clsx from "clsx";

import { CloseIcon } from "@/components/icons/Close";
import Link from "next/link";
import styles from "./size-guide-modal.module.css";

const SizeGuideModal = ({
  children,
  isRingProduct,
}: {
  children: React.ReactNode;
  isRingProduct: boolean;
}) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <span className={styles.trigger}>Size guide</span>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="dialog-overlay" />
        <Dialog.Content
          className={clsx("dialog-content", styles["sizeguide-modal"])}
        >
          <Dialog.Close className={styles.close}>
            <CloseIcon />
          </Dialog.Close>
          <Dialog.Title asChild>
            <p className={styles.modal__title}>Find your perfect fit</p>
          </Dialog.Title>
          <p className={styles.preamble}>
            Our size charts are here to guide you. They show the general body
            measurements we use for each size, not the exact dimensions of every
            garment. Since many of our designs have unique fits, we recommend
            checking the product description for specific fit notes (e.g.
            oversized, slim fit) and studio model measurements.
          </p>
          {!!isRingProduct ? (
            <>
              <h1 className={styles.preambleTitle}>
                Not sure of your ring size?
              </h1>
              <p className={styles.preamble}>
                Find your perfect fit with our easy guide. Visit our{" "}
                <Link className={styles.sizeguideLink} href="/ring-size-guide">
                  Ring Size Guide here.
                </Link>
              </p>
            </>
          ) : (
            <></>
          )}

          <span className={styles.measurementSection}>
            <p className={clsx(styles.title, styles.modal__t2)}>MEASUREMENTS</p>
            <p className={clsx(styles["preamble"], styles.spacing)}>
              All meassurements are in cm
            </p>
            {children}
          </span>
          <article className={styles.howToMeasure}>
            <h2 className={clsx(styles.title, styles.modal__t2)}>
              HOW TO MEASURE
            </h2>
            <dl className={styles.measurements}>
              <div>
                <dt>CHEST:</dt>
                <dd>Measure around the fullest part of your chest.</dd>
              </div>
              <div>
                <dt>WAIST:</dt>
                <dd>Measure the narrowest part of your waistline.</dd>
              </div>
              <div>
                <dt>HIP:</dt>
                <dd>Measure the fullest part of your hips.</dd>
              </div>
              <div>
                <dt>INSIDE LEG:</dt>
                <dd>Measure from the top of the inside leg to the floor.</dd>
              </div>
            </dl>
          </article>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default SizeGuideModal;
